import React from "react";
import LogoDark from "../images/logo_white.png";
import { Link } from "react-router-dom";

const Logo = ({ width = 110 }) => {
  return (
    <Link to="/" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}>
      <img src={LogoDark} width={width} alt="Datanomics Logo" style={{ display: 'block' }} />
    </Link>
  );
};

export default Logo;
